const permissions = {
    'isAdmin': 0,
    'seeUM': 1,
    'editUM': 2,
    'seeAllUsers': 3,
    'editProject': 4,
    'createProject': 5,
    'seeAllProjects': 6,
    'seeLayer': 7,
    'seeimportData': 10,
    'seeMasterData': 11,
    'editMasterData': 12,
    'editImportData': 13,
    'removeData': 14,
    'seeProjectData': 15,
    'editProjectData': 16,
    'seeSalesData': 17,
    'writeComments': 18,

    'seeProjectMasterData': 19,
    'seeMeasures': 20,
    'editMeasures': 21,
    'seeUtilisation': 22,
    'editUtilisation': 23,
    'seeAppointments': 24,
    'editAppointments': 25,
    'seeFrameworks ': 26,
    'editFrameworks': 27,

    'seeProjectProcessing': 30,
    'seeProcess': 31,
    'editProcess': 32,
    'seePersons': 33,
    'editPersons': 34,
    'seeParcels': 35,
    'editParcels': 36,
    'seeLandregister': 37,
    'editLandregister': 38,
    'seeCorrespondence': 65,
    'editCorrespondence': 66,
    'seeContracts': 39,
    'editContracts': 40,
    'seelawProcesses': 41,
    'editLawProcesses': 42,
    'seePayments': 43,
    'editPayments': 44,
    'seeBills': 45,
    'editBills': 46,

    'seeProjectManagement': 47,
    'seeReports': 48,
    'editReports': 49,
    'seeActionTrackers': 50,
    'editActionTrackers': 51,
    'seeStipulation': 52,
    'editStipulation': 53,
    'seeCosts': 54,
    'editCosts': 55,

    'seeProjectAdministration': 56,
    'seeTasks': 57,
    'editTasks': 58,
    'seeDataSpecification': 59,
    'editDataSpecification': 60,
    'seeAdministrationClaims': 61,
    'editAdministrationClaims': 62,
    'seeAdministrationProjects': 63,
    'editAdministrationProjects': 64
};

const permissionsIcon = {
    '0': 'pi pi-shield', // isAdmin
    '1': 'pi pi-eye', // seeUM
    '2': 'pi pi-pencil', // editUM
    '3': 'pi pi-eye', // seeNotification
    '4': 'pi pi-pencil', // editNotification
    '5': 'pi pi-pencil', // editNotificationTemplates
    '6': 'pi pi-eye', // editProject
    '7': 'pi pi-pencil', // seeAllUsers
    '8': 'pi pi-shield', // editProject
    '13': 'pi pi-shield', // importData
};

// dependencies:
// Ein Benutzer der Reports editieren kann, muss auch grafana dashboards sehen können
// Ein Benutzer der das Projekt editieren kann, muss auch Locations (Messtechnik) sehen können
// Ein Benutzer der Benachrichtiguen editieren kann, muss auch die Messtechnik sehen können
// Ein Benutzer der die Karte sehen kann, muss auch die Alarme sehen können
// ...
const dependPermissions = {
    '0': [],
    '1': [],
    '2': [1],              // editUM
    '3': [1],               // seeAllUsers
    '13': [1, 2, 11, 12],
    '12': [11]
};

export {
    permissions,
    permissionsIcon,
    dependPermissions
};
